



















import { Event, DateRange } from 'inscreva-sse-models';
import { Component, Vue, Prop } from 'vue-property-decorator';

import { EventDateHelper } from '../services/EventDateHelper';

@Component
export default class EventTimelineComponent extends Vue {
  @Prop({ required: true })
  private event!: Event;

  get dates() {
    return this.event.subEvents
      .flatMap(({ info }) =>
        ([{ ...info.date, name: info?.name }] as Array<DateRange>).concat(
          ...info.dates.filter(({ interval }) => interval === true),
        ),
      )
      .sort((dateA, dateB) =>
        dateA.interval && !dateB.interval ? 1 : new Date(dateA.end).getTime() - new Date(dateB.end).getTime(),
      );
  }

  getHour = (value: string) => value?.replace(/^.*?T(\d{2}):?(\d{2})?.*?$/, '$1') || '-';

  getMinute = (value: string) => value?.replace(/^.*?T(\d{2}):?(\d{2})?.*?$/, '$2') || '-';

  getFullHour(date: string): string {
    return `${this.getHour(date)}:${this.getMinute(date)}`;
  }

  getDate(date: DateRange) {
    return EventDateHelper.getDate(date, false);
  }

  getDateLabel(date: DateRange, index: number) {
    const commonDates = this.dates.filter((elm, elmIndex) => !elm.interval && elmIndex < index);
    const includesDate =
      !date.interval || (commonDates.length && !EventDateHelper.isSameDay(commonDates[commonDates.length - 1]));

    return `${
      date.interval && date.name ? date.name : `${commonDates.length === 0 ? 1 : commonDates.length + 1}ª Data `
    }${includesDate ? this.getDate(date) : ''} ${(!date.interval && date.name && `- ${date.name}`) || ''}`;
  }
}
